import { BaseUrlProvider } from "./BaseUrlContext";
import ReportProviderContext from "./ReportProviderContext"


const Providers = ({ children }) => {
    return (
    <BaseUrlProvider>   
        <ReportProviderContext>
            {children}
        </ReportProviderContext>
    </BaseUrlProvider>
);
};
export default Providers;